import React, {Component} from 'react';
import Select from 'react-select';
import {groupStyles} from '../../utils/SelectStyles';
import {connect} from 'react-redux';
import {hideModal, showModal,} from '../../actions/modal.actions';
import {
	clearWorkflowEngines,
	clearWorkflowEvents,
	clearWorkflowList,
	clearWorkflowOrders,
	clearWorkflowStatuses,
	clearWorkflowTransitions,
	getWorkflowEngines,
	getWorkflowEvents,
	getWorkflowList,
	getWorkflowOrders,
	getWorkflowStatuses,
	getWorkflowTransitions,
} from '../../actions/workflow.actions'
import {createLoadingSelector, getWorkflows,} from "../../selectors";
import Loader from "../../components/Loader";
import isEmpty from "../../utils/helpers";
import Workflow from "./Workflow";

class WorkflowDefinitions extends Component {

	state = {
		isLoaded: false,
		resultsNumber: "",
		searchTerm: '',
		workflows: null,
		workflowsSorted: null,
		workflowsFiltered: null,
		showFilters: false,
		engineFilter: '',
		workflowTypeFilter: '',
		collapsedGroups: {},
	}

	componentDidMount() {

		// Change navbar type and color
		document.title = 'Workflows - camvio.cloud';
		this.props.changeNavBarType('default', 'Workflows');

		// Load workflows
		this.props.getWorkflowEngines();
		this.props.getWorkflowOrders();
		this.props.getWorkflowEvents();
		this.props.getWorkflowTransitions();
		this.props.getWorkflowStatuses();
		this.props.getWorkflowList().then(response => {

			// Create object with keys to easily pull workflow info
			this.sortWorkflows(response.processDefinitions)
		});
	}

	componentDidUpdate(prevState) {

		if (
			!this.state.isLoaded &&
			!this.props.workflowEnginesLoading &&
			!this.props.workflowOrdersLoading &&
			!this.props.workflowEventsLoading &&
			!this.props.workflowTransitionsLoading &&
			!this.props.workflowListLoading &&
			!this.props.workflowStatusesLoading
			&& !isEmpty(this.state.workflowsSorted)
		) {
			this.setState({isLoaded: true});

			// Combine workflows to allow display count limit and search
			this.combineWorkflows();
		}
	}

	componentWillUnmount() {
		this.props.clearWorkflowEngines();
		this.props.clearWorkflowOrders();
		this.props.clearWorkflowEvents();
		this.props.clearWorkflowTransitions();
		this.props.clearWorkflowList();
		this.props.clearWorkflowStatuses();
	}

	sortWorkflows = (workflows) => {

		let workflowsSorted = {};

		// Create object with keys to easily pull workflow info
		workflows.map(workflow => {
			if (!workflowsSorted.hasOwnProperty(workflow.key)) {
				workflowsSorted[workflow.key] = workflow;
			}
		});

		this.setState({workflowsSorted: workflowsSorted})
	}

	getEngineDescription = (workflowEngineId) => {
		const { workflowEngines } = this.props;
		if (!workflowEngines || !workflowEngineId) return null;
		const engine = workflowEngines.find(e => e.id === workflowEngineId);
		return engine ? engine.description : null;
	}

	combineWorkflows = () => {

		const {
			workflowsSorted,
		} = this.state;

		const {
			workflowOrders,
			workflowEvents,
			workflowTransitions,
			workflowStatuses,
		} = this.props;

		if (!isEmpty(workflowsSorted)) {

			let workflows = [];

			if (!isEmpty(workflowOrders)) {
				workflowOrders.map((workflow) => {
					const details = workflowsSorted[workflow.workflowName];
					workflows.push({
						key: workflow.id,
						workflow: workflow,
						workflowDetails: details,
						workflowStatuses: workflowStatuses,
						workflowType: "Service Order",
						description: details && details.name,
						engineDescription: details && this.getEngineDescription(details.workflowEngineId),
					});
				});
			}

			if (!isEmpty(workflowEvents)) {
				workflowEvents.map((workflow) => {
					const details = workflowsSorted[workflow.workflowName];
					workflows.push({
						key: workflow.id,
						workflow: workflow,
						workflowDetails: details,
						workflowStatuses: workflowStatuses,
						workflowType: (workflow.className && workflow.className.substr(workflow.className.lastIndexOf(".") + 1)) + " " + workflow.type,
						description: details && details.description,
						engineDescription: details && this.getEngineDescription(details.workflowEngineId),
					});
				});
			}

			if (!isEmpty(workflowTransitions)) {
				workflowTransitions.map((workflow) => {
					const details = workflowsSorted[workflow.workflowName];
					workflows.push({
						key: workflow.id,
						workflow: workflow,
						workflowDetails: details,
						workflowStatuses: workflowStatuses,
						workflowType: (workflow.className && workflow.className.substr(workflow.className.lastIndexOf(".") + 1)) + " " + workflow.name,
						description: details && details.description,
						engineDescription: details && this.getEngineDescription(details.workflowEngineId),
					});
				});
			}

			// Store workflows
			this.setState({workflows: workflows}, () => {

				//	Get initial filtered workflows
				this.filterWorkflows();
			});
		}
	}

	filterWorkflows = () => {

		const {
			searchTerm,
			resultsNumber,
			workflows,
			engineFilter,
			workflowTypeFilter,
		} = this.state;

		if (!isEmpty(workflows)) {

			let workflowsFiltered = workflows;

			// Filter by current search term
			if (!isEmpty(searchTerm)) {
				workflowsFiltered = workflowsFiltered.filter(workflow =>
					workflow.description && workflow.description.toUpperCase().includes(searchTerm.trim().toUpperCase())
				);
			}

			// Filter by engine type
			if (!isEmpty(engineFilter)) {
				workflowsFiltered = workflowsFiltered.filter(workflow =>
					workflow.engineDescription === engineFilter
				);
			}

			// Filter by workflow type
			if (!isEmpty(workflowTypeFilter)) {
				workflowsFiltered = workflowsFiltered.filter(workflow =>
					workflow.workflowType === workflowTypeFilter
				);
			}

			// Get appropriate number of results
			if (!isEmpty(resultsNumber)) {
				workflowsFiltered = workflowsFiltered.slice(0, resultsNumber)
			}

			// Display filtered areas
			this.setState({
				workflowsFiltered: workflowsFiltered
			});
		}
	}

	toggleFilters = () => {
		this.setState(prev => ({ showFilters: !prev.showFilters }));
	}

	handleEngineFilterChange = (engineFilter) => {
		this.setState({ engineFilter }, () => this.filterWorkflows());
	}

	handleWorkflowTypeFilterChange = (workflowTypeFilter) => {
		this.setState({ workflowTypeFilter }, () => this.filterWorkflows());
	}

	getAvailableWorkflowTypes = () => {
		const { workflows } = this.state;
		if (!workflows) return [];
		const types = new Set(workflows.map(w => w.workflowType).filter(Boolean));
		return Array.from(types).sort();
	}

	toggleGroupCollapse = (engine) => {
		this.setState(prev => ({
			collapsedGroups: {
				...prev.collapsedGroups,
				[engine]: !prev.collapsedGroups[engine],
			}
		}));
	}

	getAvailableEngines = () => {
		const { workflows } = this.state;
		if (!workflows) return [];
		const engines = new Set(
			workflows.map(w => w.engineDescription).filter(Boolean)
		);
		return Array.from(engines).sort();
	}

	handleResultNumberChange = (e) => {
		let {value} = e.target;

		this.setState({
			resultsNumber: value
		}, () => {
			this.filterWorkflows();
		});
	}

	handleSearchChange = (event) => {
		let updatedSearchTerm = event.target.value;

		if (this.state.searchTerm !== updatedSearchTerm) {

			this.setState({
				searchTerm: updatedSearchTerm
			}, () => {

				if (this.searchChangeTimeout) {
					clearTimeout(this.searchChangeTimeout);
				}

				this.searchChangeTimeout = setTimeout(() => {
					this.filterWorkflows();
				}, 300);
			});
		}
	}

	render() {

		const {
			isLoaded,
			resultsNumber,
			searchTerm,
			workflows,
			workflowsFiltered,
			showFilters,
			engineFilter,
			workflowTypeFilter,
			collapsedGroups,
		} = this.state;

		const availableEngines = this.getAvailableEngines();
		const availableWorkflowTypes = this.getAvailableWorkflowTypes();

		return (
			<div className="cmv-container cmv-container-dashboard cmv-container-client-selected">

				<div className="tab-pane camvio-table-search" style={{borderRadius: '0.5rem'}}>
					<div className="cmv-container-dashboard-search">
						<div className="cmv-container-dashboard-filter">
							<div className="container">
								<div className="form-row">
									<div className="col-md-12">
										<div className="input-group">
											<input
												placeholder="Search workflows..."
												type="text"
												className="form-control"
												autoComplete="off"
												value={searchTerm}
												onChange={this.handleSearchChange}
												disabled={!isLoaded}
											/>
											<div className="input-group-append">
												<div className="btn-group">
													<button
														type="button"
														className={"btn btn-outline-secondary" + (showFilters ? " active" : "")}
														onClick={this.toggleFilters}
														disabled={!isLoaded}
													>
														<i className={"fas fa-solid " + (showFilters ? "fa-ban" : "fa-filter")}/>
														<span>&nbsp;Filters</span>
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						{showFilters &&
						<div className="cmv-container-dashboard-filter">
							<div className="container">
								<div className="camvioTable-plan-extra-filters">
									<div className="search">
										<Select
											className="extra-filter-select"
											styles={groupStyles}
											placeholder="All Engines"
											value={engineFilter ? { value: engineFilter, label: engineFilter } : { value: '', label: 'All Engines' }}
											onChange={opt => this.handleEngineFilterChange(opt.value)}
											options={[
												{ value: '', label: 'All Engines' },
												...availableEngines.map(e => ({ value: e, label: e })),
											]}
											isDisabled={!isLoaded}
										/>
										&nbsp;
										<Select
											className="extra-filter-select"
											styles={groupStyles}
											placeholder="All Types"
											value={workflowTypeFilter ? { value: workflowTypeFilter, label: workflowTypeFilter } : { value: '', label: 'All Types' }}
											onChange={opt => this.handleWorkflowTypeFilterChange(opt.value)}
											options={[
												{ value: '', label: 'All Types' },
												...availableWorkflowTypes.map(t => ({ value: t, label: t })),
											]}
											isDisabled={!isLoaded}
										/>
									</div>
								</div>
							</div>
						</div>
						}
					</div>

					<div className="cmv-container-table">

						{!isLoaded && <Loader />}

						{isLoaded && isEmpty(workflows) &&
						<div className="container"><p>No data found</p></div>
						}

						{!isEmpty(workflowsFiltered) && (() => {
							const groups = {};
							workflowsFiltered.forEach(workflow => {
								const engine = workflow.engineDescription || 'Unknown';
								if (!groups[engine]) groups[engine] = [];
								groups[engine].push(workflow);
							});
							return Object.keys(groups).sort().map(engine => {
								const isCollapsed = !!collapsedGroups[engine];
								return (
									<div key={engine} className="workflow-engine-group">
										<h5
											className="workflow-engine-group-header"
											onClick={() => this.toggleGroupCollapse(engine)}
										>
											<i className={"fas fa-fw " + (isCollapsed ? "fa-angle-right" : "fa-angle-down")}/>
											{engine}
											<span className="workflow-engine-group-count">{groups[engine].length}</span>
										</h5>
										{!isCollapsed && groups[engine].map(workflow => (
											<Workflow
												key={workflow.key}
												workflow={workflow.workflow}
												workflowDetails={workflow.workflowDetails}
												workflowStatuses={workflow.workflowStatuses}
												workflowType={workflow.workflowType}
												description={workflow.description}
												engineDescription={workflow.engineDescription}
												engines={this.props.workflowEngines}
											/>
										))}
									</div>
								);
							});
						})()}

					</div>
				</div>
			</div>
		);
	}
}

const loaderEngines = createLoadingSelector(['GET_WORKFLOW_ENGINES']);
const loaderOrders = createLoadingSelector(['GET_WORKFLOW_ORDERS']);
const loaderEvents = createLoadingSelector(['GET_WORKFLOW_EVENTS']);
const loaderTransitions = createLoadingSelector(['GET_WORKFLOW_TRANSITIONS']);
const loaderList = createLoadingSelector(['GET_WORKFLOW_LIST']);
const loaderStatuses = createLoadingSelector(['GET_WORKFLOW_STATUSES']);

const mapStateToProps = (state) => {

	const workflowEnginesLoading = loaderEngines(state);
	const workflowOrdersLoading = loaderOrders(state);
	const workflowEventsLoading = loaderEvents(state);
	const workflowTransitionsLoading = loaderTransitions(state);
	const workflowListLoading = loaderList(state);
	const workflowStatusesLoading = loaderStatuses(state);

	const workflowEngines = getWorkflows(state).workflowEngines;
	const workflowOrders = getWorkflows(state).workflowOrders;
	const workflowEvents = getWorkflows(state).workflowEvents;
	const workflowTransitions = getWorkflows(state).workflowTransitions;
	const workflowList = getWorkflows(state).workflowList;
	const workflowStatuses = getWorkflows(state).workflowStatuses;

	return {
		workflowEnginesLoading,
		workflowOrdersLoading,
		workflowEventsLoading,
		workflowTransitionsLoading,
		workflowListLoading,
		workflowStatusesLoading,
		workflowEngines,
		workflowOrders,
		workflowEvents,
		workflowTransitions,
		workflowList,
		workflowStatuses,
	};
};

const mapDispatchToProps = {
	showModal,
	hideModal,
	getWorkflowEngines,
	clearWorkflowEngines,
	getWorkflowOrders,
	clearWorkflowOrders,
	getWorkflowEvents,
	clearWorkflowEvents,
	getWorkflowTransitions,
	clearWorkflowTransitions,
	getWorkflowList,
	clearWorkflowList,
	getWorkflowStatuses,
	clearWorkflowStatuses,
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkflowDefinitions);
